import { defineMessages } from 'react-intl'

export const homeServicesMessages = defineMessages({
  title: {
    id: 'homeServices.title',
    description: 'Title for home services page',
    defaultMessage: 'Services',
  },
  searchPlaceholder: {
    id: 'homeServicesMessages.searchPlaceholder',
    description: 'search Placeholder for home services page',
    defaultMessage: 'Search Services',
  },
  noServicesFound: {
    id: 'homeServicesMessages.noServicesFound',
    description: 'No Services found message for home services page',
    defaultMessage: 'No Services found',
  },
  activeColumn: {
    id: 'homeServicesMessages.activeColumn',
    description: 'Label for table column "active" on home services page',
    defaultMessage: 'Active',
  },
  componentColumn: {
    id: 'homeServicesMessages.componentColumn',
    description: 'Label for table column "Component" on home services page',
    defaultMessage: 'Component',
  },
  logicalComponentColumn: {
    id: 'homeServicesMessages.logicalComponentColumn',
    description:
      'Label for table column "Logical Component" on home services page',
    defaultMessage: 'Logical Component',
  },
  variantColumn: {
    id: 'homeServicesMessages.variantColumn',
    description: 'Label for table column "Variant" on home services page',
    defaultMessage: 'Variant',
  },
  serviceTypeColumn: {
    id: 'homeServicesMessages.serviceTypeColumn',
    description: 'Label for table column "Type" on home services page',
    defaultMessage: 'Type',
  },
  zoneColumn: {
    id: 'homeServicesMessages.zoneColumn',
    description: 'Label for table column "Zone" on home services page',
    defaultMessage: 'Zone',
  },
  zoneDropdownPlaceholder: {
    id: 'homeServicesMessages.zoneDropdownPlaceholder',
    description: 'Placeholder for dropdown filter "Zone" on home services page',
    defaultMessage: 'Zone',
  },
  statusDropdownPlaceholder: {
    id: 'homeServicesMessages.statusDropdownPlaceholder',
    description:
      'Placeholder for dropdown filter "Status" on home services page',
    defaultMessage: 'Status',
  },
  allStatusesDropdownOption: {
    id: 'homeServicesMessages.allStatusesDropdownOption',
    description:
      '"All types" option label for dropdown filter "Status" on home services page',
    defaultMessage: 'All',
  },
  activeStatusesDropdownOption: {
    id: 'homeServicesMessages.activeStatusesDropdownOption',
    description:
      '"Active" option label for dropdown filter "Status" on home services page',
    defaultMessage: 'Active',
  },
  inactiveStatusesDropdownOption: {
    id: 'homeServicesMessages.inactiveStatusesDropdownOption',
    description:
      '"Inactive" option label for dropdown filter "Status" on home services page',
    defaultMessage: 'Inactive',
  },
})
